import { USER_FEATURES_KEYS } from 'consts';

import { useGetOrganisationFeatureAccess } from './useGetOrganisationFeatureAccess';

export const usePhoneOnlyAccountsFeature = () =>
  useGetOrganisationFeatureAccess(USER_FEATURES_KEYS.phoneOnlyAccounts);
